import { Component, type ErrorInfo, type ReactNode } from "react";
import { clientLog } from "./clientLog";
import { isChunkError, reloadOnce } from "./offline/chunk";

/** Log the crash; a file of an old build that is gone gets one reload, which loads the new build. */
export function crashed(error: Error, reload: () => boolean = reloadOnce): boolean {
  const chunk = isChunkError(error);
  clientLog.event("crash", { kind: chunk ? "chunk" : "render", error: error.name });
  return chunk && reload();
}

export class Crash extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[crash] the page stopped", error, info.componentStack);
    crashed(error);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <main className="narrow" role="alert" data-testid="crash">
        <h1>The page stopped</h1>
        <p>Reload the page. If it stops again, send this text to support:</p>
        <pre>{error.message}</pre>
      </main>
    );
  }
}
